import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: process.env.POSTHOG_HOST,
};

export const FlagsProvider = ({ children }: { children: React.ReactNode }) => {
  if (!process.env.POSTHOG_KEY) {
    console.warn('POSTHOG_KEY is not set');
    return <>{children}</>;
  }
  return (
    <PostHogProvider options={options} apiKey={process.env.POSTHOG_KEY}>
      {children}
    </PostHogProvider>
  );
};
